import _ from 'lodash'
import * as types from "../../store/types";

export default {
    components: {    
   
    },
    data(){
        return {
            vm:this,
            searchMixin:{    
                perPage:25,
                isloading:false,  
                payloadDataSearchKey:"value",          
                currentPage:1,
                searchText:"",
                payloadData:{},
                payloadIncludes:"",
                searchStore:"",
                defaultStore:""                
            }
        }
    },
    methods:{
        search: _.debounce((vm)=>{    
            vm.loadPage(1, true);
        },300),            
        loadPage(pageNr, fromDebounce=false){   
            let loading = this.searchMixin.isloading
            let perPage = this.searchMixin.perPage
            
            // first set the current page
            this.searchMixin.currentPage=pageNr;
            
            // if entered from search and charlength is 1 or 2 do nothing
            if(fromDebounce && this.searchMixin.searchText.length == 1 || fromDebounce && this.searchMixin.searchText.length == 2){
                return;
            }
            // if entered from search and charlength is 0 reload all users
            else if(fromDebounce && this.searchMixin.searchText.length == 0){
                loading="info"
                this.$store.dispatch(this.searchMixin.defaultStore, {data:this.searchMixin.payloadData,params:{per_page:perPage, page:pageNr, include:this.searchMixin.payloadIncludes}}).then(()=>{
                    loading=false
                })                
            }                
            // if searchlength is more then 2 always use search (so pagination works on search)
            else if(this.searchMixin.searchText.length > 2){                
                let searchData = this.searchMixin.payloadData
                searchData[this.searchMixin.payloadDataSearchKey] = this.searchMixin.searchText
                loading = "info"
                this.$store.dispatch(this.searchMixin.searchStore, {data:searchData,params:{per_page:perPage, page:pageNr, include:this.searchMixin.payloadIncludes}}).then(()=>{                    
                    loading=false
                })
            }
            // default... get all items
            else{
                loading="info"            
                this.$store.dispatch(this.searchMixin.defaultStore, {data:this.searchMixin.payloadData,params:{per_page:perPage, page:pageNr, include:this.searchMixin.payloadIncludes}} ).then(()=>{
                    loading=false
                }) 
            }                    
        },
        reset(toPage=1){                                    
            this.loadPage(toPage)
        }            
    }
}
